import { types } from 'mobx-state-tree'

const UserRoleModel = types.model('UserRoleModel', {
  role: types.optional(types.string, ''),
  localizedName: types.optional(types.string, '')
})

export default UserRoleModel
